var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.299,
    height: 16.446,
    viewBox: "0 0 23.299 16.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transportation",
    transform: "translate(-101.739 -502.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "truck",
    d: "M3.654,5H17.076a.685.685,0,0,1,.685.685V7.056h3.9a.959.959,0,0,1,.923.7l1.175,4.111a.686.686,0,0,1,.366.19l.969.969a.685.685,0,0,1,.2.485V18.02a.685.685,0,0,1-.685.685H22.558a2.741,2.741,0,0,1-5.482,0H10.223a2.741,2.741,0,0,1-5.482,0H2.685A.685.685,0,0,1,2,18.02V6.654a.685.685,0,0,1,.2-.485L3.17,5.2A.685.685,0,0,1,3.654,5Zm18.68,6.853-.979-3.426H17.761v2.741a.685.685,0,0,0,.685.685Zm-2.518,5.482a1.371,1.371,0,1,1-1.371,1.371,1.371,1.371,0,0,1,1.371-1.371ZM6.112,18.705a1.371,1.371,0,1,0,1.371-1.371A1.371,1.371,0,0,0,6.112,18.705Z",
    transform: "translate(99.739 497.277)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/transportation.bd02ce239b151a7d4f529a544b1dfb46.svg";
export { ForwardRef as ReactComponent };